<osc-base-table
    [items]="_items"
    [columns]="columns"
    [hideMarkedBar]="hideMarkedBar"
    [showCheckboxColumn]="showCheckboxColumn"
    (rowSelect)="onRowSelect($event)"
>
    <ng-container cdkColumnDef="itemNumber">
        <th cdk-header-cell *cdkHeaderCellDef>
            <osc-text-table-header
                [name]="'SPARE_PARTS.TABLE.ITEM_NO' | translate"
                class="header-availability"
            ></osc-text-table-header>
        </th>
        <td cdk-cell *cdkCellDef="let row">{{ row.rowData.itemNumber }}</td>
    </ng-container>
    <ng-container cdkColumnDef="name">
        <th cdk-header-cell *cdkHeaderCellDef>
            <osc-text-table-header
                [name]="'SPARE_PARTS.TABLE.PART_NAME' | translate"
                class="header-availability"
            ></osc-text-table-header>
        </th>
        <td cdk-cell *cdkCellDef="let row">{{ row.rowData.name }}</td>
    </ng-container>
    <ng-container cdkColumnDef="materialNumber">
        <th cdk-header-cell *cdkHeaderCellDef>
            <osc-text-table-header
                [name]="'SPARE_PARTS.TABLE.MAT_NO' | translate"
                class="header-availability"
            ></osc-text-table-header>
        </th>
        <td cdk-cell *cdkCellDef="let row">{{ row.rowData.id }}</td>
    </ng-container>
    <ng-container cdkColumnDef="amount">
        <th cdk-header-cell *cdkHeaderCellDef>
            <osc-text-table-header
                [name]="'SPARE_PARTS.TABLE.AMOUNT' | translate"
                class="header-availability"
            ></osc-text-table-header>
        </th>
        <td cdk-cell *cdkCellDef="let row">
            <sew-table-input>
                <input
                    type="number"
                    class="amount-input"
                    [readonly]="true"
                    [value]="row.rowData.installedQuantity"
                />
            </sew-table-input>
        </td>
    </ng-container>
    <ng-container cdkColumnDef="expandableRow"> </ng-container>
    <ng-container cdkColumnDef="fullRowContent"> </ng-container>
    <ng-container cdkColumnDef="groupHeaderIcon"> </ng-container>
    <ng-container cdkColumnDef="groupHeaderName"> </ng-container>
</osc-base-table>
